module.exports = __webpack_public_path__ + "static/services-banner-overlay-2c9b75d855c96b9ea9c5aab4310d2484.png";